import Loader from 'components/Loader'
import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

const AdministracionClientePropio = lazy(async () => import('./AdministracionClientePropio'))
const Flotas = lazy(async () => import('./Flotas'))
const RecaudosRecargas = lazy(async () => import('./RecaudosRecargas'))
const ReporteAuditoria = lazy(async () => import('./ReporteAuditoria'))

const GestionClientesPropios = ({ match }: any) => {
  return (
    <div className="app-wrapper">
      <Switch>
        <Suspense fallback={<Loader />}>
          <Route path={`${match.url}/administracion`} component={AdministracionClientePropio} />
          <Route path={`${match.url}/flotas`} component={Flotas} />
          <Route path={`${match.url}/movimientos`} component={RecaudosRecargas} />
          <Route path={`${match.url}/reporte-auditoria`} component={ReporteAuditoria} />
        </Suspense>
      </Switch>
    </div>
  )
}

export default GestionClientesPropios

